// Neu laden, wenn nach einem Deploy eine nachzuladende Datei fehlt
// (vite:preloadError, siehe Vite-Doku „Load Error Handling“). Der Tab
// läuft dann noch mit der alten App, deren gehashte Dateien es nicht
// mehr gibt; ein Reload holt die neue.
//
// Gegen eine Endlosschleife (Datei fehlt wirklich): nur neu laden, wenn
// die Seite schon länger als MIN_AGE_MS offen war. Nichts wird im
// Browser gespeichert.
//
// preventDefault() lässt den Import in Vite mit `undefined` enden statt
// zu werfen; React.lazy scheitert dann beim Rendern. Solange das Neuladen
// läuft (isReloadPending), fängt ReloadBoundary das ab, und Sentry sowie
// der Fehlerzähler ignorieren die Folgefehler.
const MIN_AGE_MS = 10_000;

let pending = false;

export function isReloadPending() {
  return pending;
}

export function reloadNow() {
  window.location.reload();
}

export function installChunkReload({
  now = () => performance.now(),
  reload = reloadNow
} = {}) {
  const onError = (event) => {
    if (pending || now() < MIN_AGE_MS) return;
    pending = true;
    event.preventDefault();
    reload();
  };
  window.addEventListener('vite:preloadError', onError);
  return () => window.removeEventListener('vite:preloadError', onError);
}

export function __resetChunkReloadForTests() {
  pending = false;
}
